import { render, staticRenderFns } from "./InvestmentRiskWarning.vue?vue&type=template&id=7cff6af2"
import script from "./InvestmentRiskWarning.vue?vue&type=script&lang=js"
export * from "./InvestmentRiskWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports